import { handleResponse, handleError } from "./apiUtils";
import { API, Storage, Auth } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import Resizer from "react-image-file-resizer";

const resizeAvatar = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      500,
      500,
      "PNG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

const resizeAvatarThumbnail = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      50,
      50,
      "PNG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

export async function getInternalUsers() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/internalUsers";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };

  return await API.get(apiName, path, myInit);
}

export async function getInternalNotifications() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/internalNotifications";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };

  return await API.get(apiName, path, myInit);
}

export async function getChatsList() {
  return await API.get("SupplyHubSharedAPI", "/internal/chatslist")
    .then(handleResponse)
    .catch(handleError);
}

export async function getChat(type, id) {
  return await API.get(
    "SupplyHubSharedAPI",
    "/internal/chatslist/" + type.toLowerCase() + "/" + id
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function sendMessage(data) {
  const myInit = {
    body: {
      data,
    },
  };
  return await API.put("SupplyHubSharedAPI", "/internal/sendMessage", myInit)
    .then(handleResponse)
    .catch(handleError);
}

export async function sendSMSFromChat(data) {
  const myInit = {
    body: {
      data,
    },
  };
  return await API.put(
    "SupplyHubSharedAPI",
    "/internal/sendSMSFromChat/" + data,
    myInit
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function putChatUpdateSeen(id) {
  const myInit = {};
  return await API.put(
    "SupplyHubSharedAPI",
    "/internal/chatslist/" + id + "/updateseen",
    myInit
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function putChatUpdateOwner(id, internalUserId) {
  const myInit = {
    body: {
      internalUserId,
    },
  };
  return await API.put(
    "SupplyHubSharedAPI",
    "/internal/chatslist/" + id + "/updateowner",
    myInit
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function putInternalNotification(id) {
  const myInit = {};
  return await API.put(
    "SupplyHubSharedAPI",
    "/internal/internalNotifications/" + id,
    myInit
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function putInternalNotificationOwner(id, internalUserId) {
  const myInit = {
    body: {
      internalUserId,
    },
  };
  return await API.put(
    "SupplyHubSharedAPI",
    "/internal/internalNotifications/" + id + "/updateowner",
    myInit
  )
    .then(handleResponse)
    .catch(handleError);
}

// eslint-disable-next-line no-unused-vars
export async function getInternalUser(internalUserEmail) {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/internalUsers/" + internalUserEmail;
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function getListTypes() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/listtypes";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function getPolicyDocuments() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/policydocuments";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function getClientMarketingEmailTemplates() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/clientmarketingemailtemplates";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function getStatsDays(ownershipid) {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();
  
  const apiName = "ManabaAPI";
  const path = "/internal/stats/days/" + (ownershipid || 0);
  const myInit = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  return await API.get(apiName, path, myInit);
}

export async function getStatsMonthly() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/stats/monthly";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function getStatsPreScreens() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/stats/prescreenstats";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  const blah = await API.get(apiName, path, myInit);
  console.log(blah);
  return blah;
}

export async function getStatsCalls() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/stats/callsstats";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  const blah = await API.get(apiName, path, myInit);
  console.log(blah);
  return blah;
}

export async function getStatsClientContact() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/stats/clientcontact";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function getStatsCandidates() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/stats/candidates";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function getRecentBookingStatus() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/stats/recentbookingdata";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function getWeekOnWeekStats() {
  const apiName = "SupplyHubSharedAPI";
  const path = "/internal/stats/compareweeks";
  //const path = "/internal";
  const myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
  };
  return await API.get(apiName, path, myInit);
}

export async function putInternalUserAvatar(data) {
  const uuid = uuidv4();
  const avatarfilename =
    "internalUsers/" + data.id + "/Avatar/" + uuid + data.filename;
  const avatarthumbnailfilename =
    "internalUsers/" + data.id + "/Avatar/Thumbnail-" + uuid + data.filename;

  const myInit = {
    body: {
      avatarfilename,
      avatarthumbnailfilename,
    },
  };
  const avatar = await resizeAvatar(data.file);
  const avatarThumbnail = await resizeAvatarThumbnail(data.file);
  await Storage.put(avatarfilename, avatar);
  await Storage.put(avatarthumbnailfilename, avatarThumbnail);
  return await API.put(
    "SupplyHubSharedAPI",
    "/internal/internalUsers/" + data.id + "/updateAvatar",
    myInit
  )
    .then(handleResponse)
    .catch(handleError);
}
